import React from "react";
import styled from "styled-components";
import css from "@styled-system/css";

const Item = styled("div")(
  css({
    px: "34px",
    paddingTop: "6px",
    paddingBottom: "10px",
    boxSizing: "border-box",
    border: "2px solid #000",
    height: 48,
    display: "flex",
    alignItems: "center",
    fontSize: 2,
    width: "50%",
    justifyContent: "center",

    ":first-child": {
      borderTopLeftRadius: 24,
      borderBottomLeftRadius: 24,
    },
    ":last-child": {
      borderTopRightRadius: 24,
      borderBottomRightRadius: 24,
    },
  }),
  ({ active }) => ({
    cursor: active ? "default" : "pointer",
    ":first-child": active
      ? {
          background: "#000",
          color: "#fff",
        }
      : {},
    ":last-child": active
      ? {
          border: "none",
          backgroundImage:
            "linear-gradient(292.48deg, #FFF500 -46.61%, #FF7A00 24.58%, #30E812 60.17%, #00D1FF 95.77%)",
          color: "#fff",
        }
      : {},
  })
);

const Parent = styled("nav")(
  css({
    display: "inline-flex",
    marginBottom: 40,
  })
);

export const Switcher = ({ state, items = ["Родитель", "Ребёнок"] }) => {
  const [active, setActive] = state;

  return (
    <Parent>
      {items.map((name, ix) => (
        <Item
          key={ix}
          active={ix === active}
          onClick={() => {
            setActive(ix);
          }}
        >
          {name}
        </Item>
      ))}
    </Parent>
  );
};
